import type { ManageAPI } from "~/manage-api/types";

/* height / width */
export const imageRatioValues = {
    OFFER: 1,
    BIOREX: 103 / 72,
    INSTAGRAM: 1,
    BUSINESS: 103 / 72
}

export const biorexAreaID = 13

export const CHILDREN_FOB_ID = 1090

/**
 * Configuration FOB IDs (from fragment configuration) to actual store FOB IDs mapping
 * Maps from b2c_fobs API data for each category
 */
export const FOB_ID_MAPPING: Record<number, number[]> = {
    // Fashion and accessories
    1010: [1],
    // Home accessories and leisure
    1020: [7, 8],
    // Services
    1030: [2, 3],
    // Cafès and restaurants
    1040: [9],
    // Daily consumer goods and food
    1050: [10],
    // Experiences and entertainment
    1060: [21],
    // Beauty, health and well-being
    1070: [20, 6],
    // Hotel
    1080: [22, 23],
    // Children - special case, usually handled via childrenStores field
    1090: [1090]
};

/**
 * Maps a configuration lineOfBusinessID to actual FOB IDs used in store data
 */
export function mapConfigFobToActualFobs(configFobId: number): number[] {
    const mappedFobs = FOB_ID_MAPPING[configFobId] || [];
    
    if (mappedFobs.length === 0) {
        console.error(`[configuration] No FOB mapping defined for configFobId: ${configFobId}`);
    }
    
    return mappedFobs;
}

/**
 * Debug function to log store FOB information
 * @param stores - Array of store data
 */
export function logStoreFobIds(stores: ManageAPI.Store[]) {
    const fobCounts: Record<number, number> = {};
    
    stores.forEach(store => {
        const fobId = store.fieldOfBusinessId;
        fobCounts[fobId] = (fobCounts[fobId] || 0) + 1;
    });
    
    console.info('[configuration] Store FOB ID distribution:');
    Object.entries(fobCounts)
        .sort((a, b) => Number(a[0]) - Number(b[0]))
        .forEach(([fobId, count]) => {
            console.info(`  FOB ID ${fobId}: ${count} stores`);
        });
}

export function getFobs(scdata: ManageAPI.ShoppingCenterData) {
    if (!scdata?.b2c_fobs) {
        console.error(`[configuration] No b2c_fobs data available in scdata`);
        return [];
    }
    
    const fobs = scdata.b2c_fobs.map(fob => ({
        id: (Number(fob.id) + 1) * 10 + 1000, // make it clear that this is not one to one with id from api
        fob_ids: fob.fob_ids || [],
        description: fob.description || ''
    }));
    
    return fobs;
}